import Accordions from './components/accordion'
import Anchors from './components/anchors'
import CountUp from './components/countUp'
import Animate from './components/animate'
import DaysSince from './components/daysSince'
import Parallax from './components/parallax'
import NavScroll from './components/navScroll'
import Ticker from './components/ticker'
import Share from './components/share'
import IncidentsMore from './components/incidentsMore'

console.info('%c🔥CK Started!', 'color: red; font-size: 1rem;')

// accessibility enhancements
Accordions()
Anchors()

// Share buttons (copy link / native share sheet)
Share()

// Date Formatter
DaysSince()

// Home incident list: the rows past the first 200 arrive as the reader scrolls
IncidentsMore()

// gsap
CountUp()
Animate()
Parallax()
NavScroll()
Ticker()
